<template>
  <div v-if="needAttention">
    店舗近辺の推定混雑状況を表示しています。[<a href="#" @click.prevent="close"
      >閉じる</a
    >]
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Attention',
  data: function () {
    return {
      attentionClosed: localStorage.getItem('attentionClosed')
    };
  },
  computed: {
    needAttention(): boolean {
      if (this.attentionClosed) {
        return (
          parseInt(this.attentionClosed) + 1000 * 60 * 60 * 24 * 7 <=
          new Date().getTime()
        );
      } else {
        return true;
      }
    }
  },
  methods: {
    close() {
      this.attentionClosed = new Date().getTime().toFixed();
      localStorage['attentionClosed'] = this.attentionClosed;
    }
  }
});
</script>

<style scoped lang="scss">
div {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f8d9d9 0% 0% no-repeat padding-box;

  &,
  a {
    color: #d13e3e;
    font-size: 15px;
    font-weight: bold;
  }
}

@media screen and (max-width: 374px) {
  div {
    &,
    a {
      font-size: 12px;
    }
  }
}

@media screen and (min-width: 375px) and (max-width: 767px) {
  div {
    &,
    a {
      font-size: 14px;
    }
  }
}
</style>
